import { useCallback, useMemo } from 'react';
import useMultipartMutation from './useMultipartMutation';

const buildFormData = (values: Record<string, unknown>) => {
    const data = new FormData();
    Object.keys(values).forEach(
        (key) => {
            const value = values[key];
            if (Array.isArray(value) && value.length > 0 && value[0] instanceof File) {
                value.forEach((file) => data.append(key, file));
            } else {
                data.append(key, value as any);
            }
        },
    );
    return data;
};

const useSendWorkplaceNote = () => {
    const {
        mutate: hookMutate,
        mutateAsync: hookMutateAsync,
        ...rest
    } = useMultipartMutation({
        method: 'POST',
    });
    const mutate = useCallback(
        ({
            agentId,
            workplaceId,
            note,
            files,
        }: Record<string, unknown>) => hookMutate({
            pathname: `/agents/${agentId}/workplaces/${workplaceId}/notes`,
            body: buildFormData({
                text: note,
                attachedFiles: files,
            }),
        }),
        [hookMutate],
    );

    const mutateAsync = useCallback(
        ({
            agentId,
            workplaceId,
            note,
            files,
        }: Record<string, unknown>) => hookMutateAsync({
            pathname: `/agents/${agentId}/workplaces/${workplaceId}/notes`,
            body: buildFormData({
                text: note,
                attachedFiles: files,
            }),
        }),
        [hookMutateAsync],
    );

    return useMemo(() => ({ mutate, mutateAsync, ...rest }), [mutate, mutateAsync, rest]);
};

export default useSendWorkplaceNote;
